import companyTranslations from '~/modules/company/translations';
import documentTranslations from '~/modules/document/translations';
import shipperLocationTranslations from '~/modules/shipper-locations/translations';
import shipperProjectTranslations from '~/modules/shipper-projects/translations';
import vehicleTranslations from '~/modules/vehicle/translations';

const DICTIONARIES = {
  en: {
    actual_active_date: 'Actual Active Date',
    address_gmaps: 'Address GMaps',
    any_shippers: 'Any Shippers',
    basic_profile: 'Basic Profile',
    billing_district_city_province: 'Billing District City Province',
    billing_full_address: 'Billing Full Address',
    billing_gmaps_location: 'Billing Gmaps',
    billing_postal_code: 'Billing Postal Code',
    cod_fee: 'COD Fee',
    cod_flat: 'COD Flat',
    cod_percentage: 'COD Percentage',
    cod_type: 'COD Type',
    company: 'Company',
    company_address: companyTranslations.en.address,
    company_details: companyTranslations.en.details,
    company_industry: companyTranslations.en.industry,
    contact_department: companyTranslations.en.contact_department,
    contact_division: companyTranslations.en.contact_division,
    contact_email: companyTranslations.en.contact_email,
    contact_name: companyTranslations.en.contact_name,
    contact_phone_number: companyTranslations.en.contact_phone_number,
    contract_upload: 'Contract Upload',
    create_new_location: 'Create New Location',
    create_new_project: 'Create New Project',
    create_new_shipper: 'Create New Shipper',
    document: documentTranslations.en,
    district_city_province: 'District, City, Province',
    existing_location_data: 'Existing Location Data',
    existing_project_data: 'Existing Project Data',
    existing_shipper_data: 'Existing Shipper Data',
    fleet: vehicleTranslations.en,
    individual: 'Individual',
    invoice_attention: 'Invoice Attention',
    invoice_code: 'Invoice Code',
    invoice_details: 'Invoice Details',
    invoice_entity: 'Invoice Entity',
    invoice_receipt_deadline: 'Receipt Deadline',
    invoice_receipt_schedule: 'Receipt Schedule',
    location: shipperLocationTranslations.en,
    minimum_value: 'Minimum Value',
    office_district_city_province: 'Office District City Province',
    office_full_address: 'Office Full Address',
    office_gmaps_location: 'Office Gmaps',
    office_postal_code: 'Office Postal Code',
    overtime_fee: 'Overtime Fee',
    payment_days: 'Payment Days',
    payment_terms: 'Payment Terms',
    pricing_scheme: 'Pricing Scheme',
    product_category: 'Product Category',
    project: shipperProjectTranslations.en,
    route_type: 'Route Type',
    sales_channel: companyTranslations.en.sales_channel,
    sales_name: companyTranslations.en.sales_name,
    scheme_price: 'Scheme Price',
    scheme_unit: 'Scheme Unit',
    shipper: 'Shipper',
    shipper_account_type: 'S. Account Type',
    shipper_brand: 'Shipper Brand',
    shipper_industry: 'Shipper Industry',
    tier_value: 'Tier Value',
    tiered_by: 'Tiered By',
    unit_value: 'Unit Value',
    update_existing_location: 'Update Existing Location',
    update_existing_project: 'Update Existing Project',
    update_existing_shipper: 'Update Existing Shipper',
    view_on_google_maps: 'View on Google Maps',
  },
};

export default DICTIONARIES;
